import { Navigate } from 'react-router-dom'
import { useAppSelector } from '../hooks/redux'
import { hasPermission, hasAnyPermission, type Permission } from '../utils/permissions'

interface ProtectedRouteProps {
  children: React.ReactNode
  allowedRoles?: string[]
  /** #33 (audit P3): permission-based gating song song với allowedRoles. */
  requiredPermission?: Permission
  /** Any-of permission — user cần ít nhất 1 trong list. */
  anyOfPermissions?: Permission[]
}

export default function ProtectedRoute({
  children,
  allowedRoles,
  requiredPermission,
  anyOfPermissions,
}: ProtectedRouteProps) {
  const { isAuthenticated, user } = useAppSelector((state) => state.auth)

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />
  }

  // #33: permission check (fine-grained alternative to role check)
  if (requiredPermission && user && !hasPermission(user.role, requiredPermission)) {
    return <Navigate to="/dashboard" replace />
  }
  if (anyOfPermissions && anyOfPermissions.length > 0 && user && !hasAnyPermission(user.role, anyOfPermissions)) {
    return <Navigate to="/dashboard" replace />
  }

  return <>{children}</>
}
